export const CrossIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<g clipPath="url(#clip0_27821_23669)">
				<path
					d="M12.1968 4.7435C12.4564 4.48392 12.4564 4.06307 12.1968 3.8035C11.9373 3.54392 11.5164 3.54392 11.2568 3.8035L8.00016 7.06016L4.7435 3.8035C4.48392 3.54392 4.06307 3.54392 3.8035 3.8035C3.54392 4.06307 3.54392 4.48392 3.8035 4.7435L7.06016 8.00016L3.8035 11.2568C3.54392 11.5164 3.54392 11.9373 3.8035 12.1968C4.06307 12.4564 4.48392 12.4564 4.7435 12.1968L8.00016 8.94016L11.2568 12.1968C11.5164 12.4564 11.9373 12.4564 12.1968 12.1968C12.4564 11.9373 12.4564 11.5164 12.1968 11.2568L8.94016 8.00016L12.1968 4.7435Z"
					fill="#545563"
				/>
			</g>
			<defs>
				<clipPath id="clip0_27821_23669">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
